// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2libH","inputWrap":"CustomTip_inputWrap__22-Rd"};